import {
  IDeltaHedgeExeCommonSearchParam,
  IIncrementalReport,
} from "../../../Interfaces/deltaHedgeExe";
import TableTemplate from "../../TableTemplate/tableTemplate";
import { CommonTableUI } from "../../TableTemplate/common";
import { getExeIncrementalTable } from "../../../Requests/deltaHedgeExe";
import { Additional } from "./Additional";

interface IProps {
  searchParams: IDeltaHedgeExeCommonSearchParam;
}

const DeltaHedgeExeIncremental = ({ searchParams }: IProps) => {
  return (
    <TableTemplate<IDeltaHedgeExeCommonSearchParam, IIncrementalReport>
      TableUI={({ reports, onAction }) => (
        <CommonTableUI reports={reports} onAction={onAction} AdditionalBody={Additional} />
      )}
      getDataTable={getExeIncrementalTable}
      searchParameters={searchParams}
    />
  );
};
export default DeltaHedgeExeIncremental;
